import MessageMobileListPage from 'thm/ui/common/message/MessageMobileListPage'
import { APP } from 'core-uda/model/Resource'
import BeaconPage from 'core-mobile/ui/beacon/BeaconPage'
import ThmRequestPage from 'thm/ui/umv/requestPage/ThmRequestPage'
import ThmRenderingPage from 'thm/ui/umv/ThmRenderingPage'
import SendCommandPage from 'core-mobile/ui/command/SendCommandPage'
import StatisticPage from 'core-mobile/ui/statistic/StatisticPage'
import LeftMenu from 'core-uda/ui/leftMenu/LeftMenu'
import { RIGHTS, DATA_AUTHORIZED } from 'core-uda/Rights'
import InformationPopup from 'core-cmp/msg/InformationPopup'
import 'thm/ui/umv/ThmUmvLeftMenu.css'
import UserInfosPage from 'core-uda/ui/settings/UserInfosPage'
import ResourceUI from 'core-uda/ui/ResourceUI'
import MultiLayerPage from 'core-metoc/ui/multiLayer/MultiLayerPage'

// SAR
import SarRequestPage from 'core-sar/ui/sarRequest/SarRequestPage'
import SarPage from 'core-sar/ui/searchPage/SarPage'
import GeoTiffPage from 'core-geotiff/ui/GeoTiffPage'
import SarOilPage from 'core-sar-oil/ui/sarOilPage/SarOilPage'

function isCentricAuthorized(buttonId) {
  return APP().getCurrentCentric().isLeftMenuAvailable(buttonId)
}

/**
 * @class UmvLeftMenu
 */
let ThmUmvLeftMenu = LeftMenu.extend({
  id: 'umvLeftMenu',
  i18nPrefix: 'thm.ui.umv.ThmUmvLeftMenu.',

  // override
  init: function (config) {
    let me = this,
      radarMode = DATA_AUTHORIZED('radarProductOil')
        ? 'shipOilDetection'
        : 'shipDetection'

    me._super(config)

    APP().on('centricChanged', me.proxy(me.onCentricChanged))

    me.addButtons([
      {
        id: 'criteria',
        icon: 'positionSearch',
        handler: function () {
          let page = ThmRequestPage.get()

          page.setAutoClose(false)
          page.attr('tabFloat', true)

          ThmRequestPage.openPage()
        },
        display: () => isCentricAuthorized('criteria'),
      },
      {
        id: 'sarCriteria',
        icon: 'positionSearch',
        handler: function () {
          let page = SarRequestPage.get()

          page.setAutoClose(!me.isLocked())
          page.attr('tabFloat', me.isLocked())

          SarRequestPage.openPage()
        },
        display: () => isCentricAuthorized('sarCriteria'),
      },
      {
        id: 'rendering',
        icon: 'style',
        handler: function () {
          let page = ThmRenderingPage.get()

          page.setAutoClose(!me.isLocked())
          page.attr('tabFloat', me.isLocked())

          ThmRenderingPage.openPage()
        },
        display: () => isCentricAuthorized('rendering'),
      },
      {
        id: 'mobiles',
        icon: 'mobile',
        handler: function () {
          // TrajectoryPage.openPage();
          ResourceUI.openListSelectionPage('trajectories')
        },
        authorized: function () {
          return RIGHTS('mobile.trajectoriesTab')
        },
        display: () => isCentricAuthorized('mobiles'),
      },
      {
        id: 'zones',
        icon: 'zones',
        handler: function () {
          ResourceUI.openListSelectionPage('zones')
        },
        authorized: function () {
          return DATA_AUTHORIZED('zone')
        },
        display: () => isCentricAuthorized('zones'),
      },
      {
        id: 'commands',
        icon: 'command',
        handler: function () {
          let page = SendCommandPage.get()

          page.setAutoClose(!me.isLocked())
          page.attr('tabFloat', me.isLocked())

          SendCommandPage.openPage()
        },
        authorized: function () {
          return (
            DATA_AUTHORIZED('command') &&
            RIGHTS('data.command.create') &&
            RIGHTS('positions.sendCommandsActive')
          )
        },
      },
      {
        id: 'message',
        icon: 'mail',
        title: me.msg('message.title'),
        tooltipIcon: 0,
        handler: function () {
          if (!APP().user.email) {
            InformationPopup.openPage({
              titleKey: 'emailRequired',
              textKey: 'emailRequiredText',
              onClose: function () {
                UserInfosPage.openPage()
              },
            })
            return
          } else {
            let page = MessageMobileListPage.get()

            page.setAutoClose(!me.isLocked())
            page.attr('tabFloat', me.isLocked())

            MessageMobileListPage.openPage()
          }
        },
        authorized: function () {
          return DATA_AUTHORIZED('message', 'beaconModel')
        },
        display: () => isCentricAuthorized('message'),
      },
      {
        id: 'shipDetection',
        icon: 'vesselDetection',
        title: me.msg(radarMode + '.title'),
        label: me.msg(radarMode + '.label'),
        handler: function () {
          ResourceUI.openListSelectionPage('radarProduct')
        },
        authorized: function () {
          return DATA_AUTHORIZED('radarProduct')
        },
        display: () => isCentricAuthorized('shipDetection'),
      },
      {
        id: 'layers',
        icon: 'metoc',
        handler: function () {
          let page = MultiLayerPage.get(null, {
            showMetocDate: true,
            title: I18N.msg('core-metoc.ui.MetocPage.title'),
          })
          page.setAutoClose(!me.isLocked())
          page.attr('tabFloat', me.isLocked())
          page.open({
            model: APP().multiModel.models.metoc,
          })
        },
        authorized: function () {
          return RIGHTS('map.layers.metocAuthorized')
        },
        display: () => isCentricAuthorized('layers'),
      },
      {
        id: 'statistics',
        icon: 'chart',
        handler: function () {
          let page = StatisticPage.get()

          page.setAutoClose(!me.isLocked())
          page.attr('tabFloat', me.isLocked())

          StatisticPage.openPage()
        },
        authorized: function () {
          return RIGHTS('umv.statistic')
        },
        display: () => isCentricAuthorized('statistics'),
      },
      {
        id: 'geoImages',
        icon: 'layers',
        handler: function () {
          GeoTiffPage.openPage()
        },
        authorized: function () {
          return (
            RIGHTS('data.geoTiff.authorized') && RIGHTS('data.geoimages.accept')
          )
        },
        display: () => isCentricAuthorized('geoImages'),
      },
      {
        id: 'sar',
        icon: 'buoy',
        handler: function () {
          let page = SarPage.get()

          page.setAutoClose(!me.isLocked())
          page.attr('tabFloat', me.isLocked())

          SarPage.openPage()
        },
        authorized: function () {
          return DATA_AUTHORIZED('sarOperations')
        },
        display: () => APP().getCurrentCentric().isLeftMenuAvailable('sar'),
      },
      {
        id: 'sarOil',
        icon: 'oil',
        handler: function () {
          let page = SarOilPage.get()

          page.setAutoClose(!me.isLocked())
          page.attr('tabFloat', me.isLocked())

          SarOilPage.openPage()
        },
        authorized: () => DATA_AUTHORIZED('searchAndRescueOil'),
        display: () => APP().getCurrentCentric().isLeftMenuAvailable('sarOil'),
      },
    ])
  },

  initViewModel: function () {
    let me = this
    me._super()

    me.viewModel.attr('metocModel', APP().metocModel)
    me.viewModel.attr('isCentricsHidden', !APP().isMultiCentrics())
    me.viewModel.attr('lockable', true)
  },
})

export default ThmUmvLeftMenu
